import React from "react";
import Header from "../../Components/Header";
import about from "../../Assets/HomeBG/about.jpg";
import center from "../../Assets/HomeBG/center-image.jpg";
import Footer from "../../Components/Footer/indes";
import { useNavigate } from "react-router-dom";
import WhatsApp from "../../Components/WhatsApp";
import "./About.css";

function About() {
  const navigate = useNavigate();
  return (
    <>
      <div style={{ height: 80 }}>
        <Header />
      </div>

      {/* Using Bootstrap */}
      <div>
        <div
          id="carouselExampleControls"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner" style={{ zIndex: -1 }}>
            <div className="carousel-item active">
              <img src={about} className="d-block w-100" alt="about-logo" />
            </div>
            <div className="carousel-item">
              <img src={about} className="d-block w-100" alt="about-logo" />
            </div>
            <div className="carousel-item">
              <img src={about} className="d-block w-100" alt="about-logo" />
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <div className="about-center-heading">
        {/* <h2>About</h2> */}
        <h1>
          <i className="fa-solid fa-bolt"></i> Farman & Sons
        </h1>
        <a href="#my">
          <img
            style={{ width: 100 }}
            src="https://www.mastersarrow.com/uploads/1/3/9/5/139582407/f1b199-bf31ca786d16428d841a569c9d187341-mv2_orig.gif"
            alt="about-page"
          />
        </a>
      </div>

      <div className="info-contain">
        <div
          className="info-left"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <img src={center} alt="about-page" />
        </div>
        <div
          className="info-right"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <p className="info-first-para">Over 17 Years + Experience</p>
          <h2>Experienced and Reliable Electrical Contractors</h2>
          <p className="info-second-para">
            We started out in 2005. We are locally owned and operated which
            makes our services causal as they are done by friendly and helpful
            technicians. Our mission is to service each client with a highly
            trained and courteous technician that is dependable and always
            trustworthy.
          </p>
        </div>
      </div>

      <div className="about-center-heading" style={{ marginTop: 50 }}>
        <h1>Location</h1>
      </div>

      <div className="main-contain" id="my">
        <div
          className="left-side"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <h3>
            <i className="fa-solid fa-location-dot"></i> Our Shop Address
          </h3>
          <p className="location-text">
            Farman & Sons Electric Shop Orangi Town No #5 Near Jumma Paan Shop
          </p>
          <h3>
            <i className="fa-solid fa-envelope"></i> General Enquiries
          </h3>
          <p className="contact-text">khanashhad555@gmail.com</p>
          <h3>
            <i className="fa-solid fa-phone"></i>Call US
          </h3>
          <p className="contact-text">+923201276814</p>
          <h3>
            <i className="fa-solid fa-clock"></i> Our Timing
          </h3>
          <p className="location-timing">
            Monday - Saturday : 10:00AM - 07:00PM
          </p>
        </div>
        <div
          className="right-side"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          {/* <img src={map} /> */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.7068906710124!2d67.0000784143217!3d24.9420532481266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb34003b6ec2947%3A0xa3f79092bb672cb9!2sJuma%20Pan%20Shop!5e0!3m2!1sen!2s!4v1663436208453!5m2!1sen!2s"
            title="myFrame"
          ></iframe>
        </div>
      </div>

      <div className="about-center-text">
        <p className="product-text" onClick={() => navigate("/product")}>
          <i className="fa-solid fa-arrow-right"></i> Check Our Products
        </p>
      </div>
      <div>
        <WhatsApp />
      </div>
      <Footer />
    </>
  );
}

export default About;
